// ==============================|| セクション共通のレイアウト値 ||============================== //
//
// LP と機能詳細ページのセクションは、上下の余白をすべてこの値に揃えている。
// セクションごとに py を持たせていたときは 6〜20 まで幅があり、
// 「機能一覧(pb 9) → 料金(pt 16)」のように背景色が同じ区間で余白が二重に見えていた。
//
// 縦のリズムはここだけで決めること。個別に py を上書きしないこと。

export const SECTION_PY = { xs: 7, md: 10 };
